// Utilidades puras de filtros por columna de la tabla estándar.

export const VACIO = '__vacio__';
export const ETIQUETA_VACIO = '(Vacío)';

export const esFiltroActivo = (f) =>
  !!f &&
  (!!f.texto || !!f.desde || !!f.hasta || (Array.isArray(f.valores) && f.valores.length > 0));

/** Quita los filtros vacíos para no enviarlos ni guardarlos. */
export const limpiarFiltros = (filtros = {}) =>
  Object.fromEntries(Object.entries(filtros).filter(([, f]) => esFiltroActivo(f)));

const formatearFecha = (iso) => {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

/** Texto corto de un filtro para el chip de "Filtros activos". */
export const resumenFiltro = (f) => {
  if (f.valores?.length) {
    const nombres = f.valores.map((v) => (v === VACIO ? ETIQUETA_VACIO : v));
    return nombres.length > 2
      ? `${nombres.slice(0, 2).join(', ')} +${nombres.length - 2}`
      : nombres.join(', ');
  }
  if (f.desde || f.hasta) {
    if (f.desde && f.hasta) return `${formatearFecha(f.desde)} – ${formatearFecha(f.hasta)}`;
    return f.desde ? `desde ${formatearFecha(f.desde)}` : `hasta ${formatearFecha(f.hasta)}`;
  }
  return `contiene “${f.texto}”`;
};
